import React, { useState, useEffect } from "react";
import ShelfDialog from "./ShelfDialog";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
import { jsPDF } from "jspdf";
import QRCode from "qrcode";


const Shelves = ({ open, onClose }) => {
  const [shelves, setShelves] = useState([]);
  const [selected, setSelected] = useState([]);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [editingShelf, setEditingShelf] = useState(null);
  const [isEditMode, setIsEditMode] = useState(false);

  useEffect(() => {
    if (open) {
      loadShelves();
    }
  }, [open]);

  const loadShelves = () => {
    const stored = JSON.parse(localStorage.getItem("shelf_checks") || "[]");
    const sorted = [...stored].sort((a, b) => {
      if (a.active && !b.active) return -1;
      if (!a.active && b.active) return 1;
      return (a.description || "").localeCompare(b.description || "");
    });
    setShelves(sorted);
    setSelected(Array(sorted.length).fill(false));
  };

  const handleEdit = (shelf) => {
    setEditingShelf(shelf);
    setIsEditMode(true);
    setDialogOpen(true);
  };

  const handleAdd = () => {
    setEditingShelf(null);
    setIsEditMode(false);
    setDialogOpen(true);
  };

  const handleSaveShelf = async (newData) => {
   
    if (isEditMode && editingShelf) {
    const token = localStorage.getItem("authToken");
      const countResp = await fetch("https://api.pharmacegroup.co.uk/api/countShelfItems", {
        method: "POST",
        headers: { "Content-Type": "application/json",
  "Authorization": `Bearer ${token}` },
        body: JSON.stringify({ shelfId: editingShelf._id }),
      });
      const { count } = await countResp.json();

      if (count > 0) {
        const confirm = window.confirm(`There are ${count} items assigned to this shelf. These will be automatically marked as 'Archived'. Continue?`);
        if (!confirm) {
          return;
        }
        const token = localStorage.getItem("authToken");
        await fetch("https://api.pharmacegroup.co.uk/api/resetShelfitems", {
          method: "POST",
          headers: { "Content-Type": "application/json",
  "Authorization": `Bearer ${token}` },
          body: JSON.stringify({ shelfId: editingShelf._id }),
        });
      }

      await fetch("https://api.pharmacegroup.co.uk/api/updateShelf", {
        method: "POST",
        headers: { "Content-Type": "application/json",
  "Authorization": `Bearer ${token}` },
        body: JSON.stringify({
          _id: editingShelf._id,
          ...newData
        }),
      });
    } else {
      const groupId = localStorage.getItem("userId");
      const createdDate = new Date().toISOString();

      const newShelf = {
        ...newData,
        active: true,
        groupId,
        created: createdDate,
        log: [],
      };
const token = localStorage.getItem("authToken");
      await fetch("https://api.pharmacegroup.co.uk/api/insertShelf", {
        method: "POST",
        headers: { "Content-Type": "application/json",
  "Authorization": `Bearer ${token}` },
        body: JSON.stringify(newShelf),
      });
    }

  try {
  const token = localStorage.getItem("authToken");
  const groupId = localStorage.getItem("userId");
  const response = await fetch(`https://api.pharmacegroup.co.uk/api/shelf_checks?groupId=${groupId}`, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
  const data = await response.json();
  const activeShelves = data.filter((shelf) => shelf.active === true);
  localStorage.setItem("shelf_checks", JSON.stringify(activeShelves));
} catch (err) {
  console.error("Failed to refresh shelves:", err);
}


    loadShelves();
    setDialogOpen(false);
  };

  const handleSelectAll = (checked) => {
    const updated = shelves.map((shelf) => shelf.active && checked);
    setSelected(updated);
  };

  const handlePrint = async () => {
    const doc = new jsPDF();
    const groupName = localStorage.getItem("organisationName");

    for (let idx = 0; idx < shelves.length; idx++) {
      if (!selected[idx]) continue;
      const shelf = shelves[idx];

      const qrText = `${shelf._id}#\n${shelf.description}\n${shelf.pharmacyId}\n${shelf.pharmacyName}\n${shelf.groupId}\n${groupName}`;

      // Generate PNG data URL from qrText
      const pngUrl = await QRCode.toDataURL(qrText, { width: 200, margin: 2 });

      doc.text(shelf.description || "", 10, 20);
      doc.addImage(pngUrl, "PNG", 10, 30, 60, 60);
      doc.addPage();
    }

    // Remove last blank page
    doc.deletePage(doc.getNumberOfPages());
    doc.save("shelves.pdf");
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>Shelves</DialogTitle>
      <DialogContent>
        <Button onClick={handleAdd} variant="outlined" style={{ marginRight: 8 }}>
          Add Shelf
        </Button>
        <Button onClick={handlePrint} variant="outlined">
          Print Selected
        </Button>
        <FormControlLabel
          control={
            <Checkbox
              onChange={(e) => handleSelectAll(e.target.checked)}
            />
          }
          label="Select all active"
          style={{ marginLeft: "16px" }}
        />

        <ul style={{ listStyle: "none", paddingLeft: 0 }}>
          {shelves.map((shelf, idx) => (
            <li key={shelf._id} style={{ marginBottom: "12px", borderBottom: "1px solid #ccc", paddingBottom: "8px" }}>
              <strong>{shelf.description}</strong> ({shelf.pharmacyName})<br />
              Interval: {shelf.interval} weeks, Next due: {shelf.nextdue?.split("T")[0]}<br />
              Active: {shelf.active ? "Yes" : "No"}
              <br />
              <Button onClick={() => handleEdit(shelf)} variant="outlined" size="small" style={{ marginRight: 8 }}>
                Edit
              </Button>
              <Checkbox
                checked={selected[idx]}
                onChange={(e) => {
                  const updated = [...selected];
                  updated[idx] = e.target.checked;
                  setSelected(updated);
                }}
              />
            </li>
          ))}
        </ul>

        <ShelfDialog
          open={dialogOpen}
          onClose={() => setDialogOpen(false)}
          onSave={handleSaveShelf}
          shelfData={editingShelf}
          isEdit={isEditMode}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};

export default Shelves;
